declare global {
  interface Window {
    ttq?: any
    TiktokAnalyticsObject?: string
  }
}

let initialized = false

export const TIKTOK_PIXEL_ID = 'D8D0GQRC77UBL2TTU96G'

export function initTikTokPixel(pixelId: string = TIKTOK_PIXEL_ID) {
  if (initialized || typeof window === 'undefined') return
  initialized = true
  ;(function (w: any, d: Document, t: string) {
    w.TiktokAnalyticsObject = t
    const ttq: any = (w[t] = w[t] || [])
    ttq.methods = [
      'page',
      'track',
      'identify',
      'instances',
      'debug',
      'on',
      'off',
      'once',
      'ready',
      'alias',
      'group',
      'enableCookie',
      'disableCookie',
      'holdConsent',
      'revokeConsent',
      'grantConsent',
    ]
    ttq.setAndDefer = function (target: any, method: string) {
      target[method] = function () {
        target.push([method].concat(Array.prototype.slice.call(arguments, 0)))
      }
    }
    for (let i = 0; i < ttq.methods.length; i++) {
      ttq.setAndDefer(ttq, ttq.methods[i])
    }
    ttq.instance = function (id: string) {
      const e = ttq._i[id] || []
      for (let n = 0; n < ttq.methods.length; n++) {
        ttq.setAndDefer(e, ttq.methods[n])
      }
      return e
    }
    ttq.load = function (e: string, n?: any) {
      const r = 'https://analytics.tiktok.com/i18n/pixel/events.js'
      ttq._i = ttq._i || {}
      ttq._i[e] = []
      ttq._i[e]._u = r
      ttq._t = ttq._t || {}
      ttq._t[e] = +new Date()
      ttq._o = ttq._o || {}
      ttq._o[e] = n || {}
      const script: any = document.createElement('script')
      script.type = 'text/javascript'
      script.async = true
      script.src = r + '?sdkid=' + e + '&lib=' + t
      const first = document.getElementsByTagName('script')[0]
      if (first && first.parentNode) {
        first.parentNode.insertBefore(script, first)
      } else {
        ;(document.head || document.documentElement).appendChild(script)
      }
    }
    ttq.load(pixelId)
    ttq.page()
  })(window, document, 'ttq')
}

export function trackAddToCart(overrides?: Record<string, any>) {
  if (typeof window === 'undefined' || !window.ttq) return
  try {
    window.ttq.track('AddToCart', {
      content_id: 'authentic-mexico-resort-secrets',
      content_name: 'Authentic Mexico: The Resort Secrets',
      content_type: 'product',
      content_category: 'Digital Cookbook',
      quantity: 1,
      price: 6.39,
      value: 6.39,
      currency: 'USD',
      ...(overrides || {}),
    })
  } catch (err) {
    // no-op
  }
}
